<template>
  <div class="content">
    <div class="heaad">
      <div class="item">
        <span class="item-title">入账金额</span>
        <span class="item-value">+{{income.amount}}元</span>
      </div>
    </div>
    <div class="list">
      <detail-item :title="'类型'" :value="income.type_cn"></detail-item>
      <detail-item :title="'时间'" :value="income.created_at"></detail-item>
      <detail-item :title="'订单编号'" :value="income.order_no"></detail-item>
      <detail-item :title="'设备编号'" :value="income.soft_sn"></detail-item>
      <detail-item :title="'练车城市'" :value="income.city"></detail-item>
      <detail-item :title="'登陆教练'" :value="income.coach_name"></detail-item>
      <detail-item :title="'学员信息'" :value="income.student_name"></detail-item>
      <detail-item :title="'计费时长'" :value="income.duration + '分钟'"></detail-item>
      <detail-item :title="'开始时间'" :value="income.start_time"></detail-item>
      <detail-item :title="'结束时间'" :value="income.end_time"></detail-item>
      <detail-item :title="'计费单价'" :value="income.unit_price + '元/小时'"></detail-item>
      <detail-item :title="'订单金额'" :value="income.total_amount + '元'"></detail-item>
      <detail-item :title="'服务费'" :value="income.amount + '元'"></detail-item>
      <!-- <detail-item :title="'设备当月累计'" :value="income.current_month_balance + '元'"></detail-item> -->
      <!-- <div class="item">
        <img v-if="iconurl" class="icon" :src="iconurl" alt="">
        <span class="item-title">订单明细</span>
        <span class="item-value" @click="particularsDetail(income.id)"><span>查看订单明细</span><img :src="public_path + '/static/images/arrow.svg'" alt=""></span>
      </div> -->
    </div>
  </div>
</template>
<script>
import detailItem from '@/components/detail_item'
export default {
  data () {
    return {
      public_path: process.env.PUBLICK_PATH,
      income: {},
      params: {}
    }
  },
  components: {
    'detail-item': detailItem
  },
  methods: {
    particularsDetail (id) {
      this.$router.push({
        path: '/incomeparticularsdetail',
        query: {
          id: id
        }
      })
    }
  },
  mounted () {
    let income = this.$route.params.income
    console.log(income)
    this.income = income
  }
}
</script>
<style lang="scss" scoped>
.content {
  background: #f5f5f5;
  font-size: 0;
  .heaad {
    padding: 0 .3rem;
    background: #fff;
    margin-bottom: .2rem;
    .item {
      height: 1rem;
      line-height: 1rem;
      font-size: .3rem;
      display: -webkit-flex;
      display: flex;
      align-items: center;
      .item-value {
        color: #02B389;
        font-weight: 600;
        text-align: right;
        flex: 1;
        font-size: .28rem;
      }
    }
  }
  .list {
    background: #fff;
    padding: 0 .3rem;
    .item {
      font-size: .3rem;
      display: -webkit-flex;
      display: flex;
      min-height: .90rem;
      align-items: center;
      .icon {
        width: .38rem;
        height: .29rem;
        margin-right: .28rem;
      }
      .item-title {
        flex: 1;
      }
      .item-value {
        text-align: right;
        flex: 1;
        font-size: .28rem;
        color:rgba(51, 51, 51, .6);
        span {
          color: #02B389;
          display: inline-block;
          vertical-align: middle;
          line-height: 1;
        }
        img {
          display: inline-block;
          width: .14rem;
          height: .25rem;
          margin-left: .18rem;
          vertical-align: middle;
        }
      }
    }
  }
  .bottom {
    padding: 0 .3rem;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1.3rem;
    background: #fff;
    box-shadow: 0px -3px 26px 0px rgba(200, 200, 200, 0.25);
    .clear {
      width: 2.40rem;
      height: .90rem;
      margin-top: .2rem;
      border-radius: .10rem;
      color: #02B389;
      border: 2px solid rgba(2, 179, 137, 1);
      background: none;
    }
    .pay {
      float: right;
      color: #fff;
      margin-top: .2rem;
      margin-left: .20rem;
      width: 4.20rem;
      height: .90rem;
      background: rgba(2, 179, 137, 1);
      border-radius: .10rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/incomeparticulars/Incomeparticulars.vue